<template>
<v-layout row class="mt-5">
    <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4>

  <v-card>
    <v-card-title primary-title class="grey lighten-4">
      <h3 class="headline mb-0">GA Test</h3>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      Impressum

<v-btn @click="increase">machse hinne!</v-btn>

<br> {{ counter }}

    </v-card-text>
    
  </v-card>
</v-flex>
</v-layout>
</template>

<script>
export default {
  metaInfo () {
    return { title: 'GA test'}
  },
  data () {
    return {
      counter: 0
    }
  },
  methods: {
    increase () {
      this.counter = this.counter + 1
      console.log ('counter + 1')

      this.$ga.event({
        eventCategory: 'counter',
        eventAction: 'increase',
        eventValue: this.counter
      })
    }
  }
}
</script>


